// extracted by mini-css-extract-plugin
export default {"stamp":"gnXA0kBDcihuWqbTiEX4"};